// extracted by mini-css-extract-plugin
export default {"box":"infobox_box__ZdSxr","marker":"infobox_marker__mGkV7","logos":"infobox_logos__9KG1z","topRow":"infobox_topRow__ZmZZs","botRow":"infobox_botRow__9dwUe"};